import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/familyGroups';

export async function getFamilyGroups(organizationId, token, basic = false) {
  try {
    const params = {};
    if (organizationId) params.organizationId = organizationId;
    if (basic) params.basic = 'true';

    const response = await axios.get(API_BASE_URL, {
      params,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getFamilyGroupById(id, token, basic = false) {
  try {
    const params = {};
    if (basic) params.basic = 'true';

    const response = await axios.get(`${API_BASE_URL}/${id}`, {
      params,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteFamilyGroup(id, token) {
  try {
    const response = await axios.delete(`${API_BASE_URL}/${id}`, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error deleting family group: ' + error.message);
  }
}

export async function createFamilyGroup(data, token) {
  try {
    const response = await axios.post(API_BASE_URL, data, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error creating family group: ' + error.message);
  }
}

export async function updateFamilyGroup(id, data, token) {
  try {
    const response = await axios.put(`${API_BASE_URL}/${id}`, data, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error updating family group: ' + error.message);
  }
}
